/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Logout_ValueInputs */

const en_us2_search_field_logout_value = /** @type {(inputs: Search_Field_Logout_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End the session on this device`)
};

const pt_br2_search_field_logout_value = /** @type {(inputs: Search_Field_Logout_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encerrar a sessão neste aparelho`)
};

const es_419_search_field_logout_value = /** @type {(inputs: Search_Field_Logout_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina la sesión en este dispositivo`)
};

const pt_pt2_search_field_logout_value = /** @type {(inputs: Search_Field_Logout_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar a sessão neste dispositivo`)
};

const fr_fr2_search_field_logout_value = /** @type {(inputs: Search_Field_Logout_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la session sur cet appareil`)
};

const de_de2_search_field_logout_value = /** @type {(inputs: Search_Field_Logout_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzung auf diesem Gerät beenden`)
};

const it_it2_search_field_logout_value = /** @type {(inputs: Search_Field_Logout_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina la sessione su questo dispositivo`)
};

/**
* | output |
* | --- |
* | "End the session on this device" |
*
* @param {Search_Field_Logout_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_logout_value = /** @type {((inputs?: Search_Field_Logout_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Logout_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_logout_value(inputs)
	if (locale === "es-419") return es_419_search_field_logout_value(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_logout_value(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_logout_value(inputs)
	if (locale === "de-DE") return de_de2_search_field_logout_value(inputs)
	if (locale === "it-IT") return it_it2_search_field_logout_value(inputs)
	return en_us2_search_field_logout_value(inputs)
});
export { search_field_logout_value as "search.field_logout_value" }